
export default {
  name: 'FooterLinks',
  data() {
    return {}
  },
  computed: {
    links() {
      const links = JSON.parse(JSON.stringify(this.$store.state.linkFriend))
      if (!this.$store.state.mobile) {
        return links.slice(0, 15)
      } else {
        return links.slice(0, 7)
      }
    },
    partnerList() {
      const links = JSON.parse(JSON.stringify(this.$store.state.partnerList))
      if (!this.$store.state.mobile) {
        return links.slice(0, 15)
      } else {
        return links.slice(0, 7)
      }
    },
    isHome() {
      return this.$route.name == 'lang'
    }
  }
}
